import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import getApplicationSettings from 'owa-application-settings/lib/selectors/getApplicationSettings';
import { isHosted } from 'owa-config/lib/isHosted';
import { getWin32StyleEnabledFromPrimeSettings } from './getWin32StyleEnabledFromPrimeSettings';

let getIsWin32StylingEnabled: (() => boolean) | undefined;

// Replaces the primed boot setting with the live styling selector once its store is initialized.
export function setWin32StylingEnabledGetter(getter: () => boolean): void {
    getIsWin32StylingEnabled = getter;
}

export function getIsClassicOutlookStyleEnabledForTheme(): boolean {
    return (
        getApplicationSettings('PlatformType').isMonarch &&
        (getIsWin32StylingEnabled
            ? getIsWin32StylingEnabled()
            : !isHosted() && getWin32StyleEnabledFromPrimeSettings())
    );
}

// Bypasses the forced organization theme only in Monarch while Win32 styling is enabled.
export function shouldIgnoreOrganizationThemePolicy(): boolean {
    return (
        getUserConfiguration()?.TenantThemeData?.UserPersonalizationAllowed === false &&
        !isConsumer() &&
        getApplicationSettings('PlatformType').isMonarch &&
        getIsClassicOutlookStyleEnabledForTheme()
    );
}

// Enforces the business account's organization theme unless the Monarch Win32 override applies.
export function isOrganizationThemeForced(): boolean {
    return (
        getUserConfiguration()?.TenantThemeData?.UserPersonalizationAllowed === false &&
        !isConsumer() &&
        !shouldIgnoreOrganizationThemePolicy()
    );
}

// Allows theme selection only when theme segmentation is enabled and no organization theme is forced.
export function isUserPersonalizationAllowed(): boolean {
    const userConfiguration = getUserConfiguration();
    return !!userConfiguration?.SegmentationSettings?.Themes && !isOrganizationThemeForced();
}
